import React, { Component } from "react";
import { I18n } from "react-i18next";
import i18n from "../utils/i18n";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import ReactList from "react-list";
import WordDimension from "./WordDimension";
let wordDimension = new WordDimension();

// Stateless Functional Component:
// http://buildwithreact.com/article/stateless-functional-components
const ResultItem = props => {
  return (
    <div className="row">
      <div className="span3">
        {props.item.plz}{" "}
        <Highlighter
          highlightClassName="highlighted"
          searchWords={[props.searchTerm]}
          autoEscape={true}
          textToHighlight={props.item.ort}
        />
      </div>
      <div className="span2">
        <Highlighter
          highlightClassName="highlighted"
          searchWords={[props.searchTerm]}
          autoEscape={true}
          textToHighlight={props.item.datum}
        />
      </div>
      <div className="span4">
        <Highlighter
          highlightClassName="highlighted"
          searchWords={[props.searchTerm]}
          autoEscape={true}
          textToHighlight={props.item.gebaeude}
        />
      </div>
      <div className="span2">
        <Highlighter
          highlightClassName="highlighted"
          searchWords={[props.searchTerm]}
          autoEscape={true}
          textToHighlight={props.item.orgelbauer}
        />
      </div>
      <div className="span1 hslu-link">
        <Link to={`/detail/${props.item.recentMassnahmeId}`}>
          {i18n.t("navigation.Details")} &raquo;
        </Link>
      </div>
    </div>
  );
};

class OrgelsucheResult extends Component {
  constructor(props) {
    super(props);

    this.getHeight = this.getHeight.bind(this);
  }

  getHeight(index) {
    let gebaeude = this.props.result[index].gebaeude;
    let orgelbauer = this.props.result[index].orgelbauer;

    let heightGebaeude = wordDimension.getHeight(gebaeude, 300);
    let heightOrgelbauer = wordDimension.getHeight(orgelbauer, 140);
    return Math.max(heightGebaeude, heightOrgelbauer);
  }

  render() {
    if (!this.props.searchTerm || !this.props.result) {
      return null;
    }
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row">
              <div className="span5 search-result-title">
                {t("suchResultate.Suchresultate")} {this.props.result.length}
              </div>
            </div>
            <div className="row detail-space-top-title">
              <div className="span3 search-input-title">
                {t("suchResultate.Ort")}
              </div>
              <div className="span2 search-input-title">
                {t("suchResultate.Datum")}
              </div>
              <div className="span4 search-input-title">
                {t("suchResultate.Gebaude")}
              </div>
              <div className="span3 search-input-title">
                {t("suchResultate.Orgelbauer")}
              </div>
            </div>
            <ReactList
              itemRenderer={(index, key) => (
                <ResultItem
                  item={this.props.result[index]}
                  searchTerm={this.props.searchTerm}
                  key={key}
                />
              )}
              length={this.props.result.length}
              itemSizeGetter={this.getHeight}
              type="variable"
            />
          </div>
        )}
      </I18n>
    );
  }
}

export default OrgelsucheResult;



// WEBPACK FOOTER //
// ./src/search-unified/OrgelsucheResult.js